var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 610",
    width: 34,
    height: 34,
    rx: 6,
    fill: "#FF3366"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 12.4777C17.5523 12.4777 18 12.9255 18 13.4777V17.4777C18 18.03 17.5523 18.4777 17 18.4777C16.4477 18.4777 16 18.03 16 17.4777V13.4777C16 12.9255 16.4477 12.4777 17 12.4777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20.4777C16.4477 20.4777 16 20.9255 16 21.4777C16 22.03 16.4477 22.4777 17 22.4777H17.01C17.5623 22.4777 18.01 22.03 18.01 21.4777C18.01 20.9255 17.5623 20.4777 17.01 20.4777H17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5282 6.76084C15.9775 6.50789 16.4844 6.375 17 6.375C17.5156 6.375 18.0225 6.50789 18.4718 6.76084C18.9211 7.0138 19.2976 7.37828 19.565 7.81912L19.5679 7.82386L28.0379 21.9639L28.046 21.9777C28.308 22.4313 28.4466 22.9456 28.448 23.4695C28.4495 23.9933 28.3138 24.5084 28.0544 24.9635C27.795 25.4186 27.4209 25.7978 26.9694 26.0635C26.518 26.3291 26.0048 26.4719 25.481 26.4777L25.47 26.4778L8.51903 26.4777C7.99522 26.472 7.48206 26.3291 7.03059 26.0635C6.57912 25.7978 6.20507 25.4186 5.94567 24.9635C5.68627 24.5084 5.55055 23.9933 5.55201 23.4695C5.55348 22.9456 5.69208 22.4313 5.95403 21.9777L5.96215 21.9639L14.4322 7.82387L15.29 8.33773L14.435 7.81912C14.7024 7.37828 15.0789 7.0138 15.5282 6.76084ZM16.1462 8.85438L7.68271 22.9836C7.59753 23.1334 7.55249 23.3027 7.55201 23.4751C7.55152 23.6497 7.59676 23.8214 7.68322 23.9731C7.76969 24.1248 7.89437 24.2512 8.04487 24.3397C8.19404 24.4275 8.36342 24.475 8.53642 24.4777H25.4636C25.6366 24.475 25.806 24.4275 25.9552 24.3397C26.1057 24.2512 26.2303 24.1248 26.3168 23.9731C26.4033 23.8214 26.4485 23.6497 26.448 23.4751C26.4476 23.3027 26.4025 23.1334 26.3174 22.9836L17.855 8.85637L17.8538 8.85438C17.7648 8.70833 17.6397 8.58755 17.4906 8.50361C17.3409 8.4193 17.1719 8.375 17 8.375C16.8282 8.375 16.6592 8.4193 16.5094 8.50361C16.3603 8.58755 16.2353 8.70833 16.1462 8.85438Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileError);
export default __webpack_public_path__ + "static/media/file-error.37d2f850e9b04fb0ed0033b716b3e052.svg";
export { ForwardRef as ReactComponent };